import {DialogManager} from '@modifi/plugin-dialogs'

import ConnectedPreunderwritingSubmitConfirmationDialog, {
  DIALOG_NAME as PRE_UNDERWRITING_SUBMIT_CONFIRMATION_DIALOG,
} from './preunderwriting-submit-confirmation-dialog'
import TradeDocumentsUploadDialog, {
  DIALOG_NAME as TRADE_DOCUMENTS_UPLOAD_DIALOG,
} from './high-limit-doc-upload-dialog'

DialogManager.addDialog(
  PRE_UNDERWRITING_SUBMIT_CONFIRMATION_DIALOG,
  ConnectedPreunderwritingSubmitConfirmationDialog
)
DialogManager.addDialog(TRADE_DOCUMENTS_UPLOAD_DIALOG, TradeDocumentsUploadDialog)

export {PRE_UNDERWRITING_SUBMIT_CONFIRMATION_DIALOG, TRADE_DOCUMENTS_UPLOAD_DIALOG}
